import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'tt-documents-merged-preview',
    templateUrl: './documents-merged-preview.component.html',
    styleUrls: ['./documents-merged-preview.component.css'],
})
export class DocumentsMergedPreviewComponent {
    public src;
    constructor(@Inject(MAT_DIALOG_DATA) public data: { src: string }, sanitizer: DomSanitizer, dialogRef: MatDialogRef<DocumentsMergedPreviewComponent>) {
        dialogRef.updateSize('80vw', '90vh');
        this.src = sanitizer.bypassSecurityTrustResourceUrl(data.src);
    }
}
